
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// Translation
import { injectIntl, FormattedMessage } from 'react-intl';

import withStyles from 'isomorphic-style-loader/withStyles';
import s from './VehicleMakes.css';
import {
    Button,
    FormControl
} from 'react-bootstrap';
import cx from 'classnames';

// Redux Form
import { Field, reduxForm, formValueSelector, change, submit as submitForm } from 'redux-form';

// Redux
import { connect } from 'react-redux';

// Locale
import messages from '../../../../../locale/jsonMessages';

// Submit
import submit from '../../../SearchForm/submit';
import { getDynamicName } from '../../../../../helpers/GetDynamicItemName/getDynamicName';


class VehicleMakes extends Component {

    static propTypes = {
        className: PropTypes.any
    };

    renderFormControlSelect({ input, label, placeholder, meta: { touched, error }, children, className, disabled }) {
        return (
            <FormControl componentClass="select" {...input} className={className} >
                {children}
            </FormControl>
        )
    }

    render() {
        const { className, options, locale, dynamicLanguageData } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <div className={className}>
                <p className={cx(s.captionTitle, s.textBold, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.whatTypeOfProperty} />
                </p>
                <Field name="make" component={this.renderFormControlSelect} className='commonSelectField'>
                    <option value="">
                        {formatMessage(messages.selectLabel)}
                    </option>
                    {
                        options.map((value, key) => {
                            let dynamicName = getDynamicName({ value, locale, data: dynamicLanguageData });
                            return (
                                value.isEnable == 1 && <option value={value.id} key={key}>{dynamicName.itemName || value.itemName}</option>
                            )
                        })
                    }
                </Field>
            </div>
        );
    }
}

VehicleMakes = reduxForm({
    form: 'SearchForm', // a unique name for this form
    onSubmit: submit,
    destroyOnUnmount: false,
})(VehicleMakes);

// Decorate with connect to read form values
const selector = formValueSelector('SearchForm'); // <-- same as form name

const mapState = (state) => ({
    fieldsSettingsData: state.listingFields.data,
    priceRangeLabel: selector(state, 'priceRangeLabel'),
    makeValue: selector(state, 'make'),
    locale: state?.intl?.locale,
    dynamicLanguageData: state?.dynamicListSettings?.data
});

const mapDispatch = {
    change,
    submitForm
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(VehicleMakes)));